<template>
<v-container>
<v-row>
    <v-col
        col="12"
        md="1"
        v-for="item in data" :key="item.value"
    >
        <v-card
            class="pa-2"
            outlined
            tile
        >
            <span>{{ getItemValue(item) }}</span>
        </v-card>
    </v-col>
</v-row>
</v-container>
</template>

<script>
  export default {
    name: 'ListHorizontal',
    props: {
      data: Array,
    },
    methods: {
      getItemValue(item) {
        return (item.label) ? `${item.label}:${item.value}` : item.value;
      },
    },
  };
</script>
